import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@components-clean/core/button';
import { DropDownList } from '@components-clean/core/drop-down-list';
import { Popup } from '@components-clean/core/popup/popup';
import { FilterCategory } from '@components-clean/core/study-data-filter/study-data-filter.interfaces';
import { useStudyDataFilterContext } from '@contexts-clean/study-data-filter-context';
import { CategoryConfig } from '@interfaces/central-monitoring';
import { MapConfigToFilterCategories } from '@utils-clean/study-data-filter/study-data-filter.service';
import { StudyDataFilter } from 'views-clean/components/core/study-data-filter';
import Constants from '@utils/constants';
import { useGetFilterUIConfig } from '@apis/bff-api/central-monitoring';

const StudyFilterPage = () => {
    const anchor = useRef<HTMLDivElement | null>(null);
    const [show, setShow] = useState(false);
    const [categories, setCategories] = useState<Array<FilterCategory>>([]);
    const [dataset, setDataset] = useState<number>(1);
    const [datasets, setDatasets] = useState<Array<number>>([1, 2, 3]);
    const { setSessionId } = useStudyDataFilterContext();

    /* Start of TEMP */
    // While the TYPE is known, there's issues parsing the type from the imported json
    // but this should only be temporary
    const [configUI, setConfigUI] = useState<Array<CategoryConfig>>([]);
    let orgKey = '65afce90a2553844073db3e5';
    let studyRef = '640cb77fe37e8f0001395193';
    let dataViewConfigId = '1';
    if (window.environment === Constants.environment.DEV2) {
        orgKey = '669a8bbd9c73536ebf5919ae';
        studyRef = '65f43287f343341f1f55fb7d';
        dataViewConfigId = '1';
    }

    const { data, isMutating } = useGetFilterUIConfig(studyRef, dataViewConfigId, false);
    useEffect(() => {
        if (!isMutating && data) {
            try {
                // const apiData = JSON.parse(data.filterData) as FilterData;
                setConfigUI(data.categoryConfig);
                setSessionId(data.sessionId);
            } catch {
                window.console.log('Error parsing Filter UI data');
            }
        }
    }, [isMutating]);

    useEffect(() => {
        setCategories(MapConfigToFilterCategories(configUI));
        if (!data) return;
        if (window.environment === Constants.environment.DEV2) {
            setDatasets([113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126]);
            setDataset(113);
        }
    }, [configUI]);
    /* End of TEMP */

    const { t } = useTranslation();

    const onClick = () => {
        setShow(!show);
    };

    const onApply = () => {
        setShow(false);
    };

    return (
        <div>
            <div ref={anchor}>
                <DropDownList
                    data-testid="dataset-selector"
                    data={datasets}
                    value={dataset}
                    onChange={(event) => setDataset(event.target.value as number)}
                    label="Dataset in focus"
                    style={{ width: '200px', marginBottom: '10px' }}
                    clearButton={false}
                />
                <Button
                    data-testid="filter-btn"
                    alternativeStyle
                    primary
                    disabled={isMutating}
                    onClick={onClick}
                    style={{ width: '200px', height: '34px' }}
                >
                    <FontAwesomeIcon icon={['far', 'filter']} /> {t('filters')}
                </Button>
                {!isMutating && data && (
                    <Popup
                        data-testid="study-filter-popup"
                        anchor={anchor.current}
                        show={show}
                        border="topBorder"
                        alternativeStyle
                        onBlur={() => setShow(false)}
                    >
                        <StudyDataFilter
                            data-testid="study-filter-id"
                            categories={categories}
                            onApply={onApply}
                            datasetId={dataset}
                            orgKey={orgKey}
                            studyRef={studyRef}
                        />
                    </Popup>
                )}
            </div>
        </div>
    );
};

export default StudyFilterPage;
